import { FunctionComponent, h, Fragment } from 'preact';

interface CtaProps {
  url?: string;
  urlLabel?: string;
  heading: string;
  subHeading?: string;
}

export const Cta: FunctionComponent<CtaProps> = ({ url, urlLabel, heading, subHeading }) => (
  <div className="cta cta--muted cta--seeds">
    <div className="cta__inner">
      <div className="cta__content">
        {heading && <h3 className="cta__heading">{heading}</h3>}
        {subHeading && (
          <div className="cta__lead">
            <p>{subHeading}</p>
          </div>
        )}
      </div>
      <div className="cta__action">
        {url && urlLabel && (
          <a href={url} role="button" className="button">
            <span className="button__label  ">{urlLabel}</span>
            <span className="button__icon">
              <svg aria-hidden="true" width={8} height={12} xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.32 5.434L2.788.902a.796.796 0 00-1.13 0l-.753.753a.796.796 0 000 1.13L4.114 6 .902 9.212a.796.796 0 000 1.13l.753.756a.796.796 0 001.13 0l4.531-4.532a.797.797 0 00.004-1.132z"
                  fill="currentColor"
                  fillRule="evenodd"
                />
              </svg>
            </span>
          </a>
        )}
      </div>
    </div>
  </div>
);
